<template>
  <e-dialog
    v-model="isOpened"
    center
    hide-closer
    full-with-on-tablet
    prevent-click-overlay
    width="880px"
    :fullscreen="false"
  >
    <template #title>
      <div class="h3">
        Обнаружены ошибки, в настройках подключения
        {{ channelManagerCode === ChannelManagerCode.TravelLine ? 'TravelLine' : 'Exely' }}
      </div>
    </template>

    <e-alert v-if="alertText" variant="error" class="mb-6" thin>
      <b>{{ alertText }}</b>
    </e-alert>

    <t-l-side-setting-description is-dialog />

    <div class="d-flex mt-10 flex-wrap row-gap-3">
      <e-btn v-if="interactionIdQuery" variant="secondary" prepend-icon-src="closeSvg" @click="close">
        Закрыть мастер</e-btn
      >
      <v-spacer />
      <e-btn
        v-if="interactionIdQuery"
        variant="primary"
        prepend-icon-src="refresh"
        :loading="isLoading"
        @click="refresh"
      >
        Обновить
      </e-btn>
      <e-btn v-else variant="primary" prepend-icon-src="closeSvg" :loading="isLoading" @click="skipError">
        Закрыть
      </e-btn>
    </div>
  </e-dialog>
</template>

<script setup lang="ts">
import { ref, toRef, watch } from 'vue';
import EDialog from '@/core/components/modals/Dialog.vue';
import { EAlert, EBtn } from '@/core/components/ui';
import { ChannelManagerCode } from '@/graphql/generated';
import TLSideSettingDescription from '@/parts/tariffs/components/CM/TravelLine/TLSideSettingDescription.vue';
import { useTravelLineStore } from '@/parts/tariffs/store/travelLine';

const emit = defineEmits<{
  (event: 'close'): void;
}>();

const {
  integration,
  hasExternalIntegrationIssue,
  interactionIdQuery,
  getTravelLineIntegration,
  checkActiveStep,
  activeStep,
  channelManagerCode,
} = useTravelLineStore();

const isOpened = ref(false);

const alertText = toRef(() =>
  activeStep.value === 4 && !integration.value?.master?.steps.roomCategoriesMapping?.translationTable?.length
    ? 'Нет категорий номеров для импорта'
    : '',
);

watch(
  () => hasExternalIntegrationIssue.value || alertText.value,
  (newValue) => {
    if (newValue) {
      isOpened.value = true;
    } else {
      isOpened.value = false;
    }
  },
  {
    immediate: true,
  },
);

const isLoading = ref(false);

const refresh = async () => {
  isLoading.value = true;

  await getTravelLineIntegration();
  checkActiveStep();

  isLoading.value = false;
};

const skipError = async () => {
  hasExternalIntegrationIssue.value = false;
};

const close = () => emit('close');
</script>

<style scoped lang="scss"></style>
